import WalletInfo from './WalletInfo';
import connect from './connect'

export default connect(WalletInfo);



// WEBPACK FOOTER //
// ./src/components/WalletInfo/index.js